import React from 'react';
import PlantAddEdit from './plant-add-edit';
import PlantAddEditModal from './plant-add-edit-modal';

import { MODAL_TYPES } from 'Feature/components/app-modals';

const { PLANT_ADD_EDIT } = MODAL_TYPES;

const PlantModals = () => {
  return (
    <>
      <PlantAddEdit modalId={PLANT_ADD_EDIT} />
      <PlantAddEditModal />
    </>
  );
};

export default PlantModals;
